import type { abort } from '@app/adapters/abort'
import type {
  GroupFile,
  GroupListKind,
  GroupMember,
  GroupPickerItem,
} from '@app/application/user-management/types'

import {
  pickerCompanies,
  pickerUsers,
} from '@app/application/user-management/api/groups'

export interface GroupList<T extends GroupPickerItem> {
  kind: GroupListKind
  keys: {
    title: string
    add: string
    hint: string
    search: string
    empty: string
  }
  requestKey: Parameters<typeof abort>[0]
  search: (query: string, signal?: AbortSignal) => Promise<T[] | null>
}

// The picker cancels `requestKey` and hands its signal to `search`, so both
// have to come from the same entry.
export const GROUP_LISTS: {
  member: GroupList<GroupMember>
  file: GroupList<GroupFile>
} = {
  member: {
    kind: 'member',
    keys: {
      title: 'group.panel.staff_count',
      add: 'group.panel.add_members',
      hint: 'group.panel.staff_hint',
      search: 'group.panel.search_members',
      empty: 'group.panel.no_members_added',
    },
    requestKey: 'groupMemberPicker',
    search: pickerUsers,
  },
  file: {
    kind: 'file',
    keys: {
      title: 'group.panel.files_count',
      add: 'group.panel.add_client_file',
      hint: 'group.panel.files_hint',
      search: 'group.panel.search_client_files',
      empty: 'group.panel.no_files_added',
    },
    requestKey: 'groupFilePicker',
    search: pickerCompanies,
  },
}
